import type { ReactNode } from 'react'
import type { Instance } from '../api/types.ts'
import { eur } from '../lib/format.ts'

export function statusLook(instance: Instance): { icon: string; className: string } {
  switch (instance.status) {
    case 'NOT_DONE':
      return { icon: '✕', className: 'text-[var(--color-bad)] line-through opacity-70' }
    case 'APPROVED':
      return { icon: '✓', className: 'text-[var(--color-good)]' }
    case 'CLAIMED':
      return { icon: '⏳', className: '' }
    case 'REJECTED':
      return { icon: '✕', className: 'text-[var(--color-muted)] line-through' }
    default:
      return { icon: instance.warningCount > 0 ? '⚠' : '·', className: '' }
  }
}

export function TaskRow({
  instance,
  warningThreshold,
  right,
  onClick,
}: {
  instance: Instance
  warningThreshold: number
  right?: ReactNode
  onClick?: () => void
}) {
  const look = statusLook(instance)
  const warned = instance.status === 'OK' && instance.warningCount > 0

  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 border-b border-[var(--color-line)] py-3 last:border-b-0 ${
        onClick ? 'cursor-pointer' : ''
      }`}
    >
      <span
        className={`w-5 shrink-0 text-center ${warned ? 'text-[var(--color-warn)]' : 'text-[var(--color-muted)]'}`}
      >
        {look.icon}
      </span>

      <div className="min-w-0 flex-1">
        <p className={`text-[15px] break-words ${look.className}`}>{instance.title}</p>
        {/* El motivo de un descuento se lee donde está el descuento: si hay que
            abrir otra pantalla para saber por qué, no se lee. */}
        {instance.status === 'NOT_DONE' && instance.note && (
          <p className="text-xs break-words text-[var(--color-bad)]">«{instance.note}»</p>
        )}
        <p className="text-xs text-[var(--color-muted)]">
          {instance.dueTime && <span>{instance.dueTime}</span>}
          {warned && (
            <span className="text-[var(--color-warn)]">
              {instance.dueTime ? ' · ' : ''}aviso {instance.warningCount}/{warningThreshold}
            </span>
          )}
          {instance.weight > 1 && <span> · peso {instance.weight}</span>}
        </p>
      </div>

      <span className="shrink-0 text-sm tabular-nums text-[var(--color-muted)]">
        {instance.kind === 'BONUS' ? `+${eur(instance.valueCents)}` : eur(instance.valueCents)}
      </span>

      {right}
    </div>
  )
}
